import { Box, Icon, Link } from '@cloudscape-design/components';
import { formatDateTime } from 'src/utils/generalUtils';

interface LastUpdatedIndicatorProps {
  lastUpdatedBy?: string;
  lastUpdatedAt?: string;
}

/**
 * Displays "{user}, {formatted time}" inline for answered questions.
 * User alias links to their phonetool profile.
 * Shown to all assignees so they can see who last modified a question and when.
 */
function LastUpdatedIndicator({
  lastUpdatedBy,
  lastUpdatedAt,
}: LastUpdatedIndicatorProps) {
  if (!lastUpdatedBy || !lastUpdatedAt) {
    return null;
  }

  return (
    <Box
      display="inline-block"
      fontSize="body-s"
      color="text-status-info"
      data-testid="last-updated-indicator"
    >
      <Icon name="user-profile" size="small" />{' '}
      <Link
        href={`https://phonetool.amazon.com/users/${lastUpdatedBy}`}
        external
        fontSize="body-s"
        data-testid="last-updated-by-link"
      >
        {lastUpdatedBy}
      </Link>
      , {formatDateTime(lastUpdatedAt)}
    </Box>
  );
}

export default LastUpdatedIndicator;
